import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormArray } from '@angular/forms';
import { NgxSmartModalService } from '@bssh/comp-lib';
import { cloneDeep } from 'lodash';
import { BaseModalComponent, ModalComponentType } from '../base-modal/base-modal.component';
import { BsAppLaunchFormService } from '@app/apps/bs-app-launch-form/services/bs-app-launch-form.service';
import { BasespaceFormControl, BasespaceFormProperties } from '@app/apps/bs-app-launch-form/bs-app-launch-form-controls/bs-app-launch-form-control';
import { IEditAllFieldsModalInput, IEditAllFieldsModalOutput } from './edit-all-fields-modal.interface';

@Component({
  selector: 'app-edit-all-fields-modal',
  templateUrl: './edit-all-fields-modal.component.html',
  styleUrls: ['./edit-all-fields-modal.component.scss']
})
export class EditAllFieldsModalComponent extends BaseModalComponent implements OnInit {
  @ViewChild('fieldsContainer', { read: ViewContainerRef, static: true }) 
  fieldsContainer: ViewContainerRef;

  modalComponentType = ModalComponentType.RAD;
  closable = true;
  modalType = 'editAllFieldsModal';
  
  public title = 'Edit all';
  public subtitle = '';
  public confirmButtonText = 'Save';

  public displayFields: BasespaceFormProperties<any>[] = [];
  public formArray: FormArray = new FormArray([]);

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private bsAppLaunchFormService: BsAppLaunchFormService
  ) {
    super(ngxSmartModalService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subs.sink = this.data.subscribe((data: IEditAllFieldsModalInput) => {
      if (data && data.displayFields) {
        this.displayFields = data.displayFields;
        this.subtitle = data.subtitle;
        this.initializeFields();
      }
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  /**
   * Initialize fields with cleared/empty values
   */
  private initializeFields(): void {
    this.fieldsContainer.clear();
    this.formArray = new FormArray([]);

    this.displayFields.forEach((field) => {
      // Use the form service to initialize and render the field
      this.bsAppLaunchFormService.initializeFormField(
        cloneDeep(field),
        this.fieldsContainer,
        this.formArray
      );
    });

    // Clear values and disable form update triggers for modal controls
    this.formArray.controls.forEach((formControl: BasespaceFormControl<any>) => {
        formControl.setValue(null);
        formControl.disableFormUpdateTriggers = true;
    });
  }

  /**
   * Override accept to emit the field values
   */
  accept(modal: any): void {
    const output: IEditAllFieldsModalOutput = {
      fieldValues: this.formArray.value
    };

    this.modal.setData(output, true);
    this.confirm.emit(output);
  }
}

